import {
  IonContent,
  IonIcon,
  IonImg,
  IonItem,
  IonLabel,
  IonList,
  IonMenu,
} from '@ionic/react';
import { useLocation } from 'react-router-dom';
import './Menu.css';
import { isStaff } from './extras/Functions';
import { useAppSelector } from '../Hooks';
import { selectUser } from '../reducers/UserReducer';
import { default as dashboard_icon} from "../AE2/static/icons/menu/Dashboard.svg"
import { default as customers_icon} from "../AE2/static/icons/menu/Customers.svg"
import { default as resources_icon} from "../AE2/static/icons/menu/Resources.svg"
import { default as alpha_white_icon} from "../AE2/static/icons/menu/Alpha Insights Logo-White.svg"
import { default as collapse_icon} from "../AE2/static/icons/menu/Collapse.svg"
import { default as expand_icon} from "../AE2/static/icons/menu/Expand.svg"
import { default as alpha_a_icon} from "../AE2/static/icons/menu/Alpha Insights Secondary Logo-White.svg"
import { default as settings_icon} from "../AE2/static/icons/menu/Settings.svg"
import Logout from './auth/Logout';
import { useState } from 'react';

interface props{
    collapsedMenu:Boolean,
    toggleCollapsedMenu: ()=>void
}

interface AppPage {
  url: string;
  iconUrl: string;
  title: string;
  staff: boolean
}

const appPages: AppPage[] = [
  {
    title: 'Dashboard',
    url: '/',
    iconUrl:dashboard_icon,
    staff: false
  },
  {
    title: 'Customers',
    url: '/customers',
    iconUrl:customers_icon,
    staff:true
  },
  {
    title: 'Resources',
    url: '/resources',
    iconUrl:resources_icon,
    staff:true
  },
//   {
//     title: 'Analytics',
//     url: '/analytics',
//     iconUrl:'../assets/es.png',
//     staff:true
//   },
];

const MenuV2: React.FC<props> = ({collapsedMenu, toggleCollapsedMenu}) => {
  const location = useLocation();
  const user = useAppSelector(selectUser)
  const [imageKey, setImageKey] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  

  const handleClick = () =>{
    window.location.href = '/'
  }

  const handleToggle = () => {
    setIsTransitioning(true);
    toggleCollapsedMenu();
    setImageKey(prev => prev + 1);
    setTimeout(() => setIsTransitioning(false), 50);
    
  }


  return (
    <IonMenu contentId="main" type="overlay">
      <IonContent className='bg-navy'>
        <div className='h-100' style={{display:'flex', flexDirection:'column',justifyContent:'space-between'}}>
        <IonList className='bg-transparent'>
          <div className='menu-logo-container'>
            {/* <AE2Icon className='ae2-logo' onClick={() => handleClick()}/> */}
            <IonImg key={imageKey} className="ae2_banner" style={{width:'100%'}} onClick={() => handleClick()} src={collapsedMenu ?  alpha_a_icon : alpha_white_icon}/>
            <div className='collapse_icon'>
                <IonIcon onClick={()=>handleToggle()} src={collapsedMenu ? expand_icon :collapse_icon}></IonIcon>
            </div>
          </div>

          {appPages.map((appPage, index) => {

            if(!appPage.staff || (appPage.staff && isStaff(user))){
              if (isTransitioning) {
                //prevents buttons showing up to soon for a split second
                return null;
              }
            return(                         
                    collapsedMenu ? 
                    <IonItem key={index} className={location.pathname===appPage.url ? ' icon-only-item bg-cobalt-blue bg-hover-navy': ' icon-only-item bg-hover-navy bg-transparent'} routerLink={appPage.url} routerDirection="none" lines="none" detail={false}>
                        <IonIcon  src={appPage.iconUrl}/>
                    </IonItem>  :              
                    <IonItem key={index} className={location.pathname===appPage.url ? 'bg-cobalt-blue bg-hover-navy': 'bg-transparent bg-hover-navy'} routerLink={appPage.url} routerDirection="none" lines="none" detail={false}>
                        <IonIcon slot='start' src={appPage.iconUrl}/>
                        <IonLabel className='text-white font-helvetica font-16pt'>{appPage.title}</IonLabel>
                    </IonItem>       
          );
            }
            else{
              return null
            }
          })}

        </IonList>
        <IonList className='bg-transparent'>
          {isTransitioning ? null : collapsedMenu ? 
          <><IonItem className=' icon-only-item bg-transparent pointer bg-hover-navy' routerLink={''} routerDirection="none" lines="none" detail={false}>
                <IonIcon src={settings_icon} />
              </IonItem><IonItem className='bg-transparent bg-hover-navy'>
                  <Logout collapsed={collapsedMenu}/>
                </IonItem></> : 
          <><IonItem className='bg-transparent' routerLink={''} routerDirection="none" lines="none" detail={false}>
              <IonItem className='bg-transparent bg-hover-navy pointer' >
                <IonIcon slot='start' src={settings_icon} />
                <IonLabel className='text-white text-hover-black font-helvetica font-16pt'>Settings</IonLabel>
              </IonItem>
              </IonItem><IonItem className='bg-transparent'>
                  <Logout collapsed={collapsedMenu}/>
                </IonItem></>}
        </IonList>
        </div>
      </IonContent>
    </IonMenu>
  );
};

export default MenuV2;
